// Données mockées réalistes pour PURSUE FR — Archives UAP déclassifiées

export const STATS = {
  total: 161,
  ministere_guerre: 82,
  fbi: 57,
  nasa: 15,
  etat: 7,
  hors_terre: { lune: 8, orbite_basse: 2, sans_date: 1, sans_lieu: 47 },
};

export const AGENCIES = [
  { id: 'DOW', label: "Ministère de la Guerre", short: 'MG', count: 82, color: '#fbbf24', hex: 'amber' },
  { id: 'FBI', label: 'FBI', short: 'FBI', count: 57, color: '#38bdf8', hex: 'cyan' },
  { id: 'NASA', label: 'NASA', short: 'NASA', count: 15, color: '#a78bfa', hex: 'violet' },
  { id: 'STATE', label: "Département d'État", short: 'DE', count: 7, color: '#34d399', hex: 'emerald' },
  { id: 'CIA', label: 'CIA', short: 'CIA', count: 22, color: '#dc2626', hex: 'rose' },
];

export const TYPES = [
  { id: 'case_file', label: 'Dossier d\'enquête', count: 2631 },
  { id: 'mission_report', label: 'Rapport de mission', count: 152 },
  { id: 'photo', label: 'Photographie', count: 24 },
  { id: 'transcript', label: 'Transcription', count: 24 },
  { id: 'report', label: 'Rapport', count: 246 },
  { id: 'other', label: 'Autre', count: 940 },
];

export const ERAS = [
  { id: 'pre-1960', label: 'Avant 1960', count: 3162 },
  { id: '1960-79', label: '1960 — 1979', count: 141 },
  { id: '1980-99', label: '1980 — 1999', count: 187 },
  { id: '2000-19', label: '2000 — 2019', count: 124 },
  { id: '2020+', label: '2020 et après', count: 496 },
];

// 32 dossiers représentatifs — chacun affichera dans l'archive
export const DOSSIERS = [
  {
    id: 'PR-001', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'Observation UAP au-dessus du Moyen-Orient — Mai 2022',
    location: 'Moyen-Orient', country: 'Syrie', lat: 35.0, lng: 38.0,
    date: '2022-05-14', releaseDate: '2026-05-08',
    summary: "Un opérateur militaire américain a signalé un phénomène aérien non identifié traversant son écran de capteur infrarouge. L'objet présentait une signature thermique anormale et une vitesse incompatible avec les aéronefs connus.",
    pages: 12, sizeMb: 3.2,
    image: 'https://images.unsplash.com/photo-1604011410887-604dd961416e?w=900&q=80',
    tags: ['infrarouge', 'capteur', 'opérateur', 'non résolu'],
  },
  {
    id: 'PR-002', agency: 'DOW', type: 'mission_report', classification: 'SECRET DÉCLASSIFIÉ',
    title: 'UAP signalé aux Émirats Arabes Unis — Octobre 2023',
    location: 'Émirats Arabes Unis', country: 'EAU', lat: 24.46, lng: 54.37,
    date: '2023-10-22', releaseDate: '2026-05-08',
    summary: "Capture vidéo d'un phénomène aérien non identifié au large des EAU. Forme sphérique avec trajectoire erratique observée par un pilote de chasse en mission de reconnaissance.",
    pages: 8, sizeMb: 2.1,
    image: 'https://images.unsplash.com/photo-1597635814707-93ba3c274c1d?w=900&q=80',
    tags: ['vidéo', 'pilote', 'sphère', 'reconnaissance'],
  },
  {
    id: 'PR-003', agency: 'DOW', type: 'photo', classification: 'NON CLASSIFIÉ',
    title: 'Phénomène anormal au-dessus de la Grèce — Octobre 2023',
    location: 'Mer Égée', country: 'Grèce', lat: 38.0, lng: 24.0,
    date: '2023-10-04', releaseDate: '2026-05-08',
    summary: "Lignes de viseur aqua sur fond gris avec dispersion de nuages et formes rectangulaires sombres. Détection radar inhabituelle au large des côtes grecques.",
    pages: 4, sizeMb: 1.4,
    image: 'https://images.unsplash.com/photo-1654587170928-edf46f71ef76?w=900&q=80',
    tags: ['radar', 'maritime', 'égée'],
  },
  {
    id: 'PR-004', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'UAP volant droit au-dessus de l\'océan — Grèce, Octobre 2023',
    location: 'Grèce', country: 'Grèce', lat: 37.9, lng: 23.7,
    date: '2023-10-17', releaseDate: '2026-05-08',
    summary: "Un opérateur militaire américain a signalé un UAP près de la Grèce volant en ligne droite au-dessus de l'océan en direction des terres. Vitesse estimée supérieure à Mach 3.",
    pages: 6, sizeMb: 1.8,
    image: 'https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=900&q=80',
    tags: ['supersonique', 'maritime', 'opérateur'],
  },
  {
    id: 'PR-005', agency: 'DOW', type: 'photo', classification: 'SECRET DÉCLASSIFIÉ',
    title: 'Contraste octogonal au capteur infrarouge — Moyen-Orient, 2013',
    location: 'Moyen-Orient', country: 'Irak', lat: 33.3, lng: 44.4,
    date: '2013-07-09', releaseDate: '2026-05-08',
    summary: "Image d'une vidéo présentant une zone de contraste à huit pointes capturée via capteur infrarouge. Origine et nature inconnues malgré analyse approfondie.",
    pages: 5, sizeMb: 1.6,
    image: 'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?w=900&q=80',
    tags: ['infrarouge', 'octogonal', 'analyse'],
  },
  {
    id: 'PR-006', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'UAP dans l\'espace aérien africain — 2025',
    location: 'Afrique', country: 'Soudan', lat: 12.0, lng: 30.0,
    date: '2025-03-21', releaseDate: '2026-05-08',
    summary: "Opérateur militaire américain ayant signalé un UAP en opérant dans l'espace aérien africain. Objet en mouvement contre-vent à haute altitude.",
    pages: 7, sizeMb: 2.0,
    image: 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=900&q=80',
    tags: ['afrique', 'haute altitude', 'contre-vent'],
  },
  {
    id: 'PR-007', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'UAP rapporté par l\'US Air Force — Sud des États-Unis, 2020',
    location: 'Sud des États-Unis', country: 'États-Unis', lat: 31.0, lng: -97.0,
    date: '2020-11-04', releaseDate: '2026-05-08',
    summary: "En 2020, l'US Air Force a signalé un phénomène aérien non identifié dans le sud des États-Unis. Observation par plusieurs témoins indépendants et capture radar.",
    pages: 9, sizeMb: 2.4,
    image: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=900&q=80',
    tags: ['usaf', 'radar', 'multi-témoins'],
  },
  {
    id: 'PR-008', agency: 'DOW', type: 'photo', classification: 'NON CLASSIFIÉ',
    title: 'Objet en forme de ballon de football — Près du Japon, 2024',
    location: 'Japon', country: 'Japon', lat: 35.68, lng: 139.76,
    date: '2024-08-12', releaseDate: '2026-05-08',
    summary: "Le Commandement Indo-Pacifique des États-Unis a signalé un UAP ressemblant à un corps en forme de ballon de football près du Japon. Stationnaire pendant 14 minutes avant disparition rapide.",
    pages: 11, sizeMb: 3.0,
    image: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=900&q=80',
    tags: ['indopacom', 'stationnaire', 'forme allongée'],
  },
  {
    id: 'PR-009', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'UAP en Amérique du Nord — Département de l\'Armée, 2026',
    location: 'Amérique du Nord', country: 'États-Unis', lat: 40.0, lng: -100.0,
    date: '2026-02-18', releaseDate: '2026-05-08',
    summary: "L'armée américaine a signalé un UAP en Amérique du Nord en 2026. Phénomène détecté simultanément par trois stations radar distinctes.",
    pages: 14, sizeMb: 4.1,
    image: 'https://images.unsplash.com/photo-1419833173245-f59e1b93f9ee?w=900&q=80',
    tags: ['armée', 'multi-radar', 'détection'],
  },
  {
    id: 'FBI-001', agency: 'FBI', type: 'case_file', classification: 'DÉCLASSIFIÉ',
    title: 'Croquis composite — Observation FBI Septembre 2023',
    location: 'Sud-Est des États-Unis', country: 'États-Unis', lat: 33.0, lng: -84.0,
    date: '2023-09-15', releaseDate: '2026-05-08',
    summary: "Recréation d'une potentielle observation anormale dans le sud-est des États-Unis en septembre 2023. Croquis basé sur le témoignage de trois civils ayant observé l'objet pendant environ 8 minutes.",
    pages: 3, sizeMb: 0.9,
    image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=900&q=80',
    tags: ['croquis', 'civil', 'témoignage'],
  },
  {
    id: 'FBI-002', agency: 'FBI', type: 'case_file', classification: 'DÉCLASSIFIÉ',
    title: 'Photo infrarouge — Objet non identifié, Ouest US Décembre 2025',
    location: 'Ouest des États-Unis', country: 'États-Unis', lat: 39.7, lng: -111.0,
    date: '2025-12-03', releaseDate: '2026-05-08',
    summary: "Image fixe infrarouge (chaud sur noir) capturée d'un objet non identifié au-dessus de l'ouest des États-Unis en décembre 2025. Vitesse et altitude incohérentes avec aéronef civil.",
    pages: 6, sizeMb: 1.7,
    image: 'https://images.unsplash.com/photo-1532953030881-d815a2b07b6f?w=900&q=80',
    tags: ['infrarouge', 'ouest', 'inconnue'],
  },
  {
    id: 'FBI-003', agency: 'FBI', type: 'case_file', classification: 'DÉCLASSIFIÉ',
    title: 'Photo A5 — Cible infrarouge Ouest des États-Unis',
    location: 'Ouest des États-Unis', country: 'États-Unis', lat: 40.0, lng: -112.0,
    date: '2025-12-04', releaseDate: '2026-05-08',
    summary: "Seconde capture infrarouge issue du même incident — vue rapprochée révélant une signature thermique annulaire inhabituelle.",
    pages: 2, sizeMb: 0.7,
    image: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=900&q=80',
    tags: ['infrarouge', 'annulaire'],
  },
  {
    id: 'FBI-004', agency: 'FBI', type: 'photo', classification: 'DÉCLASSIFIÉ',
    title: 'Cible B2 sous hélicoptère — Ouest des États-Unis, Septembre 2025',
    location: 'Ouest des États-Unis', country: 'États-Unis', lat: 38.5, lng: -110.5,
    date: '2025-09-22', releaseDate: '2026-05-08',
    summary: "Image infrarouge (chaud sur noir) capturée d'un objet non identifié au-dessous d'un hélicoptère au-dessus de l'ouest des États-Unis. Trajectoire de suivi anormale.",
    pages: 4, sizeMb: 1.2,
    image: 'https://images.unsplash.com/photo-1465353438678-313b3ee30cad?w=900&q=80',
    tags: ['hélicoptère', 'infrarouge', 'suivi'],
  },
  {
    id: 'FBI-005', agency: 'FBI', type: 'photo', classification: 'DÉCLASSIFIÉ',
    title: 'Image B18 — Objet(s) multiples, Ouest US',
    location: 'Ouest des États-Unis', country: 'États-Unis', lat: 39.0, lng: -113.0,
    date: '2025-09-23', releaseDate: '2026-05-08',
    summary: "Image infrarouge capturée d'objets non identifiés au-dessus de l'ouest des États-Unis. Formation triangulaire à 3 sources thermiques distinctes.",
    pages: 5, sizeMb: 1.5,
    image: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=900&q=80',
    tags: ['multiples', 'formation', 'triangulaire'],
  },
  {
    id: 'FBI-006', agency: 'FBI', type: 'case_file', classification: 'DÉCLASSIFIÉ',
    title: 'Dossier 65_HS1 — Rapports Soucoupes Volantes 1957',
    location: 'Côte à Côte', country: 'États-Unis', lat: 39.5, lng: -98.0,
    date: '1957-06-15', releaseDate: '2026-05-08',
    summary: "Reports en cascade de soucoupes volantes inondant les États-Unis. Plusieurs personnes ont rapporté avoir vu une boule rouge planer au-dessus de la centrale du Atomic Energy Commission près de Augusta, Georgie.",
    pages: 18, sizeMb: 5.2,
    image: 'https://images.unsplash.com/photo-1546199881-3454b82b832b?w=800',
    tags: ['1957', 'soucoupe', 'energie atomique'],
  },
  {
    id: 'NASA-001', agency: 'NASA', type: 'mission_report', classification: 'DÉCLASSIFIÉ',
    title: 'Apollo 17 — Trois lumières au-dessus du terrain lunaire, 1972',
    location: 'Lune', country: 'Hors-Terre', lat: 0, lng: 0,
    date: '1972-12-11', releaseDate: '2026-05-08',
    summary: "Image d'archives de la mission Apollo 17 vers la Lune. La zone agrandie contient trois lumières visibles au-dessus du terrain lunaire — origine et nature non expliquées par la NASA à ce jour.",
    pages: 7, sizeMb: 2.3,
    image: 'https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=900&q=80',
    tags: ['apollo', 'lune', '1972'],
  },
  {
    id: 'NASA-002', agency: 'NASA', type: 'transcript', classification: 'DÉCLASSIFIÉ',
    title: 'Transcription Gemini 7 — Observation orbitale 1965',
    location: 'Orbite basse', country: 'Hors-Terre', lat: 0, lng: 0,
    date: '1965-12-15', releaseDate: '2026-05-08',
    summary: "Transcription radio de l'équipage de Gemini 7 décrivant un objet non identifié évoluant en orbite parallèle à la capsule pendant approximativement 4 minutes.",
    pages: 24, sizeMb: 6.8,
    image: 'https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=800',
    tags: ['gemini', 'orbite', 'radio'],
  },
  {
    id: 'STATE-001', agency: 'STATE', type: 'report', classification: 'DÉCLASSIFIÉ',
    title: 'Câble UAP — Mexico, Septembre 2003',
    location: 'Mexico', country: 'Mexique', lat: 19.43, lng: -99.13,
    date: '2003-09-16', releaseDate: '2026-05-08',
    summary: "Câble diplomatique du Département d'État américain relatant une observation UAP signalée par les autorités mexicaines au-dessus de la capitale. Multiple témoins militaires.",
    pages: 7, sizeMb: 1.2,
    image: 'https://images.unsplash.com/photo-1504711331083-9c895941bf81?w=800',
    tags: ['mexico', 'câble', 'diplomatique'],
  },
  {
    id: 'STATE-002', agency: 'STATE', type: 'report', classification: 'DÉCLASSIFIÉ',
    title: 'Câble UAP — Tbilissi, Géorgie, Octobre 2001',
    location: 'Tbilissi', country: 'Géorgie', lat: 41.71, lng: 44.83,
    date: '2001-10-30', releaseDate: '2026-05-08',
    summary: "Câble du Département d'État américain rapportant une observation UAP au-dessus de Tbilissi par plusieurs civils et militaires géorgiens.",
    pages: 4, sizeMb: 0.8,
    image: 'https://images.unsplash.com/photo-1504711331083-9c895941bf81?w=800',
    tags: ['géorgie', 'câble', 'multi-témoins'],
  },
  {
    id: 'STATE-003', agency: 'STATE', type: 'report', classification: 'DÉCLASSIFIÉ',
    title: 'Câble UAP — Achgabat, Turkménistan, Novembre 2004',
    location: 'Achgabat', country: 'Turkménistan', lat: 37.95, lng: 58.38,
    date: '2004-11-05', releaseDate: '2026-05-08',
    summary: "Câble diplomatique rapportant un phénomène lumineux non identifié au-dessus d'Achgabat. Observation par personnel d'ambassade.",
    pages: 3, sizeMb: 0.6,
    image: 'https://images.unsplash.com/photo-1504711331083-9c895941bf81?w=800',
    tags: ['turkménistan', 'lumière', 'ambassade'],
  },
  {
    id: 'NASA-003', agency: 'NASA', type: 'photo', classification: 'DÉCLASSIFIÉ',
    title: 'Observation lunaire — Mission Apollo, 1969',
    location: 'Lune', country: 'Hors-Terre', lat: 0, lng: 0,
    date: '1969-07-21', releaseDate: '2026-05-08',
    summary: "Photographies d'archives de la NASA montrant des anomalies lumineuses non expliquées en orbite lunaire pendant la mission Apollo 11.",
    pages: 5, sizeMb: 1.4,
    image: 'https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=800',
    tags: ['apollo 11', 'lune', 'anomalie'],
  },
  {
    id: 'PR-010', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'Incident Tic-Tac — USS Nimitz, Pacifique 2004',
    location: 'Océan Pacifique', country: 'États-Unis', lat: 33.0, lng: -119.0,
    date: '2004-11-14', releaseDate: '2026-05-08',
    summary: "Engagement du F/A-18 du Commandant David Fravor avec un objet de forme tic-tac près de l'USS Nimitz. Capacités de vol défiant la physique connue : descente de 24 000 m à la mer en moins de 1 seconde.",
    pages: 32, sizeMb: 8.7,
    image: 'https://images.unsplash.com/photo-1597635814707-93ba3c274c1d?w=800',
    tags: ['tic-tac', 'nimitz', 'fravor', 'pacifique'],
  },
  {
    id: 'PR-011', agency: 'DOW', type: 'mission_report', classification: 'SECRET DÉCLASSIFIÉ',
    title: 'Incident Gimbal — USS Theodore Roosevelt, 2015',
    location: 'Atlantique', country: 'États-Unis', lat: 33.0, lng: -77.0,
    date: '2015-01-21', releaseDate: '2026-05-08',
    summary: "Capture vidéo FLIR d'un objet tournant sur lui-même contre le vent à haute altitude. Plusieurs pilotes témoins. Vidéo officiellement reconnue par le Pentagone en 2020.",
    pages: 19, sizeMb: 5.3,
    image: 'https://images.unsplash.com/photo-1654587170928-edf46f71ef76?w=800',
    tags: ['gimbal', 'flir', 'roosevelt', 'atlantique'],
  },
  {
    id: 'PR-012', agency: 'DOW', type: 'mission_report', classification: 'SECRET DÉCLASSIFIÉ',
    title: 'Incident GoFast — Atlantique 2015',
    location: 'Atlantique', country: 'États-Unis', lat: 33.0, lng: -78.0,
    date: '2015-01-21', releaseDate: '2026-05-08',
    summary: "Vidéo GoFast capturée par un F/A-18 Super Hornet montrant un objet sphérique se déplaçant à grande vitesse au-dessus de la surface de l'océan Atlantique.",
    pages: 11, sizeMb: 2.9,
    image: 'https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=800',
    tags: ['gofast', 'super hornet', 'sphère'],
  },
  {
    id: 'FBI-007', agency: 'FBI', type: 'case_file', classification: 'DÉCLASSIFIÉ',
    title: 'Memo Hottel — Roswell, 1950',
    location: 'Roswell', country: 'États-Unis', lat: 33.39, lng: -104.52,
    date: '1950-03-22', releaseDate: '2026-05-08',
    summary: "Memo de l'agent spécial Guy Hottel adressé au Directeur du FBI relatif à trois soucoupes volantes récupérées au Nouveau-Mexique avec corps d'occupants de petite taille à l'intérieur.",
    pages: 1, sizeMb: 0.3,
    image: 'https://images.unsplash.com/photo-1546199881-3454b82b832b?w=800',
    tags: ['hottel', 'roswell', '1950', 'historique'],
  },
  {
    id: 'FBI-008', agency: 'FBI', type: 'case_file', classification: 'DÉCLASSIFIÉ',
    title: 'Dossier Project Blue Book — Sélection 1968',
    location: 'États-Unis', country: 'États-Unis', lat: 39.0, lng: -98.0,
    date: '1968-04-12', releaseDate: '2026-05-08',
    summary: "Documents extraits du Project Blue Book de l'US Air Force, étude officielle des UAP entre 1952 et 1969. Plus de 12 000 incidents documentés.",
    pages: 47, sizeMb: 12.4,
    image: 'https://images.pexels.com/photos/8371715/pexels-photo-8371715.jpeg?w=800',
    tags: ['blue book', 'usaf', 'historique'],
  },
  {
    id: 'PR-013', agency: 'DOW', type: 'transcript', classification: 'NON CLASSIFIÉ',
    title: 'Audition au Congrès — David Grusch, Juillet 2023',
    location: 'Washington D.C.', country: 'États-Unis', lat: 38.89, lng: -77.04,
    date: '2023-07-26', releaseDate: '2026-05-08',
    summary: "Transcription complète du témoignage sous serment de David Grusch, ancien officier du renseignement, devant le Sous-comité de la Chambre des représentants des États-Unis sur la sécurité nationale.",
    pages: 87, sizeMb: 18.2,
    image: 'https://images.unsplash.com/photo-1604011410887-604dd961416e?w=800',
    tags: ['congrès', 'grusch', 'audition', 'sous serment'],
  },
  {
    id: 'PR-014', agency: 'DOW', type: 'mission_report', classification: 'NON CLASSIFIÉ',
    title: 'Cluster lumineux — Phoenix, Arizona, Mars 1997',
    location: 'Phoenix', country: 'États-Unis', lat: 33.45, lng: -112.07,
    date: '1997-03-13', releaseDate: '2026-05-08',
    summary: "Les célèbres Lumières de Phoenix : formation en V de lumières silencieuses observée par des milliers de témoins au-dessus de l'Arizona, du Nevada et de Sonora, Mexique.",
    pages: 22, sizeMb: 6.1,
    image: 'https://images.unsplash.com/photo-1604011410887-604dd961416e?w=800',
    tags: ['phoenix', '1997', 'formation v', 'masse'],
  },
  {
    id: 'PR-015', agency: 'DOW', type: 'report', classification: 'SECRET DÉCLASSIFIÉ',
    title: 'Rapport AARO — Annual UAP Assessment 2024',
    location: 'Multiple', country: 'International', lat: 0, lng: 0,
    date: '2024-11-14', releaseDate: '2026-05-08',
    summary: "Rapport annuel du All-domain Anomaly Resolution Office (AARO) sur les phénomènes anormaux. 757 nouveaux cas examinés, 18 % restant non résolus après analyse complète.",
    pages: 56, sizeMb: 14.7,
    image: 'https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=800',
    tags: ['aaro', 'rapport annuel', '2024'],
  },
  {
    id: 'NASA-004', agency: 'NASA', type: 'report', classification: 'DÉCLASSIFIÉ',
    title: 'Rapport NASA UAP Independent Study Team, 2023',
    location: 'Washington D.C.', country: 'États-Unis', lat: 38.89, lng: -77.04,
    date: '2023-09-14', releaseDate: '2026-05-08',
    summary: "Rapport final de l'équipe d'étude indépendante de la NASA sur les UAP. Recommande l'utilisation de l'IA et du machine learning pour analyser les phénomènes non identifiés.",
    pages: 36, sizeMb: 9.1,
    image: 'https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=800',
    tags: ['nasa', 'rapport indépendant', 'ia'],
  },
  {
    id: 'PR-016', agency: 'DOW', type: 'photo', classification: 'NON CLASSIFIÉ',
    title: 'Observation Aguadilla — Porto Rico, 2013',
    location: 'Aguadilla', country: 'Porto Rico', lat: 18.43, lng: -67.15,
    date: '2013-04-25', releaseDate: '2026-05-08',
    summary: "Vidéo infrarouge d'un objet rouge volant à basse altitude au-dessus de l'aéroport d'Aguadilla, plongeant dans l'océan Atlantique puis ressortant intact. Analysé par Scientific Coalition for UAP Studies.",
    pages: 14, sizeMb: 3.8,
    image: 'https://images.unsplash.com/photo-1597635814707-93ba3c274c1d?w=800',
    tags: ['porto rico', 'aguadilla', 'transmédium'],
  },
];

export const VIDEOS = [
  {
    id: 'V001',
    title: "FLIR · GIMBAL · GOFAST — Compilation officielle DoD",
    description: "Les trois vidéos officiellement déclassifiées par le Pentagone le 27 avril 2020. 0:00 GOFAST · 0:34 GIMBAL · 1:07 FLIR1 (Tic-Tac, Nimitz 2004). Authenticité confirmée par le Département de la Défense.",
    youtubeId: 'cdJLaqNEFMM',
    duration: '1:44', date: '2020-04-27', agency: 'DOW',
    location: 'Pacifique / Atlantique', tags: ['flir', 'gimbal', 'gofast', 'pentagone', 'officielle'],
    thumbnail: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=900&q=80',
  },
  {
    id: 'V002',
    title: "GOFAST — Vidéo officielle Navy (DoD)",
    description: "Vidéo GOFAST officiellement diffusée par le Département de la Défense en 2020. Capturée par un F/A-18 Super Hornet en janvier 2015 au large de la côte Est américaine. Objet sphérique à grande vitesse rasant la surface de l'océan.",
    youtubeId: '4pRWXpxm8Ls',
    duration: '0:35', date: '2015-01-21', agency: 'DOW',
    location: 'Atlantique', tags: ['gofast', 'navy', 'sphère', 'officielle'],
    thumbnail: 'https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=900&q=80',
  },
  {
    id: 'V003',
    title: "Reportage Pentagone — Les trois vidéos déclassifiées (CNBC)",
    description: "Reportage de CNBC sur la publication officielle des trois vidéos UAP par le Pentagone le 27 avril 2020. Contexte complet, audio des pilotes et analyse des incidents côte Est.",
    youtubeId: 'rO_M0hLlJ-Q',
    duration: '3:18', date: '2020-04-28', agency: 'DOW',
    location: 'Washington', tags: ['pentagone', 'cnbc', 'briefing', 'déclassification'],
    thumbnail: 'https://images.unsplash.com/photo-1419833173245-f59e1b93f9ee?w=900&q=80',
  },
  {
    id: 'V004',
    title: "Cdt. David Fravor décrit le « Tic-Tac » devant le Congrès",
    description: "Témoignage sous serment du Commandant David Fravor (US Navy retraité) devant le sous-comité de la Chambre des Représentants le 26 juillet 2023. Récit complet de son engagement avec l'objet Tic-Tac près de l'USS Nimitz en novembre 2004.",
    youtubeId: 'I94u4_Wb82E',
    duration: '4:18', date: '2023-07-26', agency: 'DOW',
    location: 'Washington', tags: ['fravor', 'tic-tac', 'témoignage', 'congrès'],
    thumbnail: 'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?w=900&q=80',
  },
  {
    id: 'V005',
    title: "Audition du Congrès UAP — David Grusch (extraits)",
    description: "Extraits de l'audition historique de David Grusch, ancien officier du renseignement de l'US Air Force, témoignant sous serment de l'existence d'un programme gouvernemental de récupération de vaisseaux d'origine non humaine.",
    youtubeId: '9wHyoEOyT6Q',
    duration: '11:45', date: '2023-07-26', agency: 'DOW',
    location: 'Washington', tags: ['grusch', 'audition', 'congrès', 'récupération'],
    thumbnail: 'https://images.unsplash.com/photo-1604011410887-604dd961416e?w=900&q=80',
  },
  {
    id: 'V006',
    title: "Audition complète du Congrès UAP — Juillet 2023 (C-SPAN)",
    description: "Diffusion intégrale de l'audition du sous-comité de la Chambre sur les phénomènes anormaux non identifiés. Trois témoins sous serment : David Grusch, David Fravor, Ryan Graves. Source officielle C-SPAN.",
    youtubeId: 'lcrCMLVk614',
    duration: '2:41:00', date: '2023-07-26', agency: 'DOW',
    location: 'Washington', tags: ['audition', 'congrès', 'c-span', 'intégrale'],
    thumbnail: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&q=80',
  },
  {
    id: 'V007',
    title: "Aguadilla 2013 — Vidéo douanes US (analyse SCU)",
    description: "Séquence infrarouge des douanes américaines au-dessus de l'aéroport Rafael Hernández à Porto Rico, 25 avril 2013. Analyse détaillée par Robert Powell et la Scientific Coalition for UAP Studies. Objet transmédium discuté.",
    youtubeId: 'q6s5RwqnnLM',
    duration: '10:34', date: '2013-04-25', agency: 'DOW',
    location: 'Porto Rico', tags: ['aguadilla', 'transmédium', 'scu', 'infrarouge'],
    thumbnail: 'https://images.unsplash.com/photo-1597635814707-93ba3c274c1d?w=900&q=80',
  },
  {
    id: 'V008',
    title: "Les Lumières de Phoenix — Documentaire complet",
    description: "Documentaire complet sur l'événement des Lumières de Phoenix du 13 mars 1997. Témoignages directs, analyses d'experts audio/vidéo confirmant l'authenticité des images, et investigation sur la formation en V observée par des milliers de personnes en Arizona.",
    youtubeId: 'I51A6l4e8_k',
    duration: '1:43:03', date: '1997-03-13', agency: 'DOW',
    location: 'Arizona', tags: ['phoenix', '1997', 'formation v', 'masse', 'documentaire'],
    thumbnail: 'https://images.unsplash.com/photo-1534447677768-be436bb09401?w=900&q=80',
  },
];

export const TIMELINE = [
  { year: 1947, date: '24 juin 1947', title: "Observation de Kenneth Arnold", desc: "Aviateur civil observe 9 objets en forme de soucoupe au-dessus du Mont Rainier — naissance du terme « soucoupe volante ».", agency: 'Civil', highlight: true },
  { year: 1947, date: '7 juillet 1947', title: "Incident de Roswell", desc: "Récupération supposée d'un engin et de corps non humains au Nouveau-Mexique. Première couverture officielle US Army.", agency: 'DOW', highlight: true },
  { year: 1948, date: 'Janvier 1948', title: "Projet Sign", desc: "Premier programme officiel de l'US Air Force pour étudier les soucoupes volantes.", agency: 'DOW' },
  { year: 1952, date: 'Juillet 1952', title: "Survol de Washington D.C.", desc: "Multiples objets non identifiés détectés au radar au-dessus du Capitole pendant 7 nuits.", agency: 'DOW', highlight: true },
  { year: 1952, date: 'Mars 1952', title: "Projet Blue Book lancé", desc: "Étude officielle des UAP par l'US Air Force, plus de 12 000 incidents documentés jusqu'en 1969.", agency: 'DOW' },
  { year: 1961, date: '19 septembre 1961', title: "Enlèvement Betty et Barney Hill", desc: "Premier cas largement médiatisé d'enlèvement supposé par des êtres non humains au New Hampshire.", agency: 'FBI' },
  { year: 1965, date: 'Décembre 1965', title: "Gemini 7 observation orbitale", desc: "Équipage Gemini 7 rapporte un objet non identifié en orbite parallèle pendant 4 minutes.", agency: 'NASA' },
  { year: 1969, date: 'Décembre 1969', title: "Fin du Projet Blue Book", desc: "L'US Air Force met fin à l'étude officielle. 701 cas restent non résolus.", agency: 'DOW' },
  { year: 1980, date: 'Décembre 1980', title: "Incident de Rendlesham Forest", desc: "Personnel militaire US à la base RAF Bentwaters au Royaume-Uni observe et touche un objet atterri dans la forêt.", agency: 'DOW', highlight: true },
  { year: 1989, date: 'Novembre 1989', title: "Vague belge", desc: "Plus de 13 500 témoins observent des objets triangulaires au-dessus de la Belgique entre 1989-1990. F-16 envoyés en interception.", agency: 'Civil', highlight: true },
  { year: 1997, date: '13 mars 1997', title: "Lumières de Phoenix", desc: "Formation en V de lumières silencieuses observée par des milliers de témoins en Arizona.", agency: 'DOW', highlight: true },
  { year: 2004, date: '14 novembre 2004', title: "Incident USS Nimitz « Tic-Tac »", desc: "Engagement officiel des F/A-18 avec un objet défiant la physique connue.", agency: 'DOW', highlight: true },
  { year: 2013, date: '25 avril 2013', title: "Vidéo Aguadilla (Porto Rico)", desc: "Douanes US filment un objet transmédium en infrarouge.", agency: 'DOW' },
  { year: 2015, date: 'Janvier 2015', title: "Incidents GIMBAL et GOFAST", desc: "Capture vidéo officielle Navy d'objets aux capacités anormales.", agency: 'DOW', highlight: true },
  { year: 2017, date: 'Décembre 2017', title: "Révélation AATIP par le New York Times", desc: "Existence du Advanced Aerospace Threat Identification Program rendue publique.", agency: 'DOW', highlight: true },
  { year: 2020, date: 'Avril 2020', title: "Pentagone confirme l'authenticité des vidéos", desc: "Le DoD reconnaît officiellement la véracité des vidéos FLIR1, Gimbal et GoFast.", agency: 'DOW', highlight: true },
  { year: 2021, date: 'Juin 2021', title: "Premier rapport ODNI sur les UAP", desc: "Le Directeur du renseignement national publie un rapport sur 144 incidents — 143 restent non expliqués.", agency: 'DOW' },
  { year: 2022, date: 'Juillet 2022', title: "Création de l'AARO", desc: "All-domain Anomaly Resolution Office créé pour centraliser l'analyse des UAP.", agency: 'DOW' },
  { year: 2023, date: '26 juillet 2023', title: "Audition historique au Congrès", desc: "David Grusch, ancien officier du renseignement, témoigne sous serment de l'existence d'un programme de récupération.", agency: 'DOW', highlight: true },
  { year: 2023, date: '14 septembre 2023', title: "Rapport NASA UAP Independent Study", desc: "L'équipe indépendante de la NASA recommande l'utilisation de l'IA pour analyser les phénomènes.", agency: 'NASA' },
  { year: 2024, date: 'Novembre 2024', title: "Rapport annuel AARO", desc: "757 nouveaux cas examinés, 18 % restent non résolus après analyse approfondie.", agency: 'DOW' },
  { year: 2026, date: '19 février 2026', title: "Directive Présidentielle Trump", desc: "Donald J. Trump ordonne la déclassification massive des dossiers UAP gouvernementaux.", agency: 'DOW', highlight: true },
  { year: 2026, date: '8 mai 2026', title: "PURSUE Release 01", desc: "Première vague de 161 documents déclassifiés par le Ministère de la Guerre. Historique.", agency: 'DOW', highlight: true },
];

export const TESTIMONIES = [
  {
    id: 'T01', name: "Cdt. David Fravor", role: "Commandant, US Navy (retraité)",
    rank: 'Top Gun · USS Nimitz · VFA-41 Black Aces', date: '2023-07-26', credibility: 5,
    quote: "Ce que nous avons vu ce jour-là près de l'USS Nimitz était réel. L'objet n'avait pas d'ailes, pas de propulsion visible. Il est passé de 24 000 mètres au niveau de la mer en moins d'une seconde.",
    incident: 'Incident Tic-Tac · Nimitz 2004',
    bio: "Pilote F/A-18F avec 18 ans dans la Marine. Commandant du VFA-41 Black Aces le 14 novembre 2004 au large de la Californie.",
    youtubeId: 'I94u4_Wb82E',
    avatar: 'https://img.youtube.com/vi/I94u4_Wb82E/hqdefault.jpg',
  },
  {
    id: 'T02', name: "David Grusch", role: "Ancien officier du renseignement, USAF/NRO",
    rank: 'Major · UAP Task Force · NRO', date: '2023-07-26', credibility: 5,
    quote: "Le gouvernement américain dispose d'un programme de récupération et de rétro-ingénierie d'engins d'origine non humaine depuis des décennies, ainsi que de biologiques non humains. J'ai interviewé plus de 40 témoins.",
    incident: 'Audition Congrès américain · 2023',
    bio: "Représentant du National Reconnaissance Office à la UAP Task Force du DoD entre 2019 et 2021. Vétéran décoré d'Afghanistan.",
    youtubeId: '9wHyoEOyT6Q',
    avatar: 'https://img.youtube.com/vi/9wHyoEOyT6Q/hqdefault.jpg',
  },
  {
    id: 'T03', name: "Cdt. Ryan Graves", role: "Pilote F/A-18, US Navy",
    rank: 'VFA-11 Red Rippers · USS Theodore Roosevelt', date: '2023-07-26', credibility: 5,
    quote: "Nous voyions ces objets quotidiennement au large de la côte Est entre 2014 et 2015. Ils étaient sur nos radars, capturés par nos caméras FLIR. Nous avons failli en percuter un. C'est un risque majeur pour la sécurité aérienne.",
    incident: 'Incidents GIMBAL/GOFAST · 2014–2015',
    bio: "Pilote F/A-18 pendant 10 ans dans la Marine. Fondateur de Americans for Safe Aerospace.",
    youtubeId: 'lcrCMLVk614',
    avatar: 'https://img.youtube.com/vi/lcrCMLVk614/hqdefault.jpg',
  },
  {
    id: 'T04', name: "Lt. Cdt. Alex Dietrich", role: "Pilote F/A-18, US Navy (retraitée)",
    rank: 'Black Aces · USS Nimitz', date: '2021-05-16', credibility: 5,
    quote: "Je le répète : c'était réel. L'objet était blanc, lisse, sans propulsion visible, et il a réagi à notre présence. Aucun de nous quatre n'a une explication conventionnelle.",
    incident: 'Incident Tic-Tac · Nimitz 2004',
    bio: "Pilote présente le 14 novembre 2004 lors de l'engagement de Fravor avec l'objet Tic-Tac. Témoin direct interviewé par 60 Minutes.",
    avatar: 'https://ui-avatars.com/api/?name=Alex+Dietrich&background=1e293b&color=fbbf24&size=256&bold=true',
  },
  {
    id: 'T05', name: "Sgt. Jim Penniston", role: "Sécurité USAF · RAF Bentwaters",
    rank: '81st Security Police Squadron', date: '1980-12-26', credibility: 4,
    quote: "J'ai touché l'objet. Surface lisse comme du verre fondu, mais métallique. J'ai vu des symboles gravés que j'ai immédiatement reproduits dans mon carnet officiel. Trente ans plus tard, ces symboles ont été déchiffrés comme code binaire.",
    incident: 'Forêt de Rendlesham · 1980',
    bio: "Déployé sur la base américaine RAF Bentwaters au Royaume-Uni lors de l'incident du 26 décembre 1980, considéré comme le « Roswell britannique ».",
    avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/James_Penniston_2010.jpg/440px-James_Penniston_2010.jpg',
  },
  {
    id: 'T06', name: "Gov. Fife Symington III", role: "Ancien Gouverneur de l'Arizona",
    rank: 'Pilote USAF · Gouverneur 1991–1997', date: '1997-03-13', credibility: 5,
    quote: "Ce que j'ai vu cette nuit-là au-dessus de Phoenix était massif, silencieux, et clairement pas humain. Comme pilote militaire et ancien officier de l'Air Force, je peux affirmer qu'aucun avion connu ne correspond.",
    incident: 'Lumières de Phoenix · 1997',
    bio: "Gouverneur de l'Arizona pendant l'événement. Ancien pilote de l'US Air Force et témoin direct des Lumières de Phoenix.",
    avatar: 'https://upload.wikimedia.org/wikipedia/commons/3/3a/Fife_Symington_III.jpg',
  },
  {
    id: 'T07', name: "Sén. Marco Rubio", role: "Sénateur US · Vice-président Comité Renseignement",
    rank: 'Sénat américain · SSCI', date: '2023-06-08', credibility: 5,
    quote: "J'ai parlé avec plusieurs témoins ayant des récits extrêmement crédibles concernant un programme de rétro-ingénierie de technologies non humaines. Ces personnes occupent des positions de très haute autorisation au sein du gouvernement.",
    incident: 'Déclarations publiques · 2023',
    bio: "Vice-président du Comité sénatorial du Renseignement. A poussé pour les législations sur la transparence UAP (UAPDA).",
    avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Marco_Rubio_official_portrait_117th_Congress.jpg/440px-Marco_Rubio_official_portrait_117th_Congress.jpg',
  },
  {
    id: 'T08', name: "Lt. Col. Karl Nell", role: "Officier renseignement, US Army (retraité)",
    rank: 'Lieutenant-Colonel · UAP Task Force', date: '2023-07-26', credibility: 5,
    quote: "L'affirmation que des intelligences non humaines existent et interagissent avec l'humanité est une réalité incontestable. La question n'est plus de savoir si, mais quand l'humanité acceptera cette vérité.",
    incident: 'Déclaration officielle · 2023',
    bio: "Officier de carrière du renseignement militaire. A collaboré avec David Grusch sur la UAP Task Force du Pentagone.",
    avatar: 'https://img.youtube.com/vi/lcrCMLVk614/hqdefault.jpg',
  },
  {
    id: 'T09', name: "Lue Elizondo", role: "Ancien directeur AATIP, DoD",
    rank: 'Directeur · AATIP (2010–2017)', date: '2017-12-16', credibility: 5,
    quote: "Le programme AATIP a recueilli des preuves matérielles, des données radar, des vidéos et des témoignages. Ce que nous avons documenté défie toute explication conventionnelle.",
    incident: 'Révélation AATIP · 2017',
    bio: "Ancien officier du renseignement militaire qui a dirigé l'Advanced Aerospace Threat Identification Program (AATIP) du Pentagone.",
    avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Lue_Elizondo_2024.jpg/440px-Lue_Elizondo_2024.jpg',
  },
];
